import parse from 'html-react-parser'
import { Link } from 'react-router'

interface Props {
  imageUrl?: string | null
  title?: string
  /** Intro copy: HTML written in the control panel. */
  introHtml?: string
}

/** Hero image, title and intro of a collection landing page. */
export default function CategoryHeader({ imageUrl, title, introHtml }: Props) {
  return (
    <section className="qt-container mt-5 md:mt-8">
      <nav aria-label="Breadcrumb" className="mb-4 text-[13px] font-semibold text-qt-muted">
        <Link to="/" className="hover:underline">
          Home
        </Link>{' '}
        <span aria-hidden="true">/</span> <span aria-current="page">{title}</span>
      </nav>
      <div className="rounded-[32px] bg-qt-soft p-2 md:p-3">
        <div className={`qt-stitch grid items-center gap-6 rounded-3xl p-6 md:p-10 ${imageUrl ? 'md:grid-cols-[minmax(0,1fr)_420px] md:gap-10' : ''}`}>
          <div className="flex flex-col gap-3">
            {title && <h1 className="text-3xl leading-tight font-extrabold text-qt-ink md:text-5xl">{title}</h1>}
            {introHtml && <div className="qt-prose text-base leading-7 md:text-[17px]">{parse(introHtml)}</div>}
          </div>
          {imageUrl && (
            <img src={imageUrl} alt="" width="840" height="560" className="aspect-[3/2] w-full rounded-2xl bg-white object-cover" fetchPriority="high" />
          )}
        </div>
      </div>
    </section>
  )
}
